var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment confirmation"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12312_27570)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -530,
    y: -512,
    width: 1440,
    height: 690,
    rx: 8,
    fill: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment confirmation_2",
    filter: "url(#filter0_dd_12312_27570)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12312_27570)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -262,
    width: 440,
    height: 310,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 8890",
    filter: "url(#filter1_d_12312_27570)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_12312_27570",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -62H380V-12H0V-62Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380 -12V-13H0V-12V-11H380V-12Z",
    fill: "#C6C6C8",
    mask: "url(#path-3-inside-1_12312_27570)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 8891",
    filter: "url(#filter2_d_12312_27570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 15.5H15V13H5V15.5ZM5 11.75H20V9.25H5V11.75ZM5 8H20V5.5H5V8ZM0 25.5V3C0 2.3125 0.244792 1.72396 0.734375 1.23438C1.22396 0.744792 1.8125 0.5 2.5 0.5H22.5C23.1875 0.5 23.776 0.744792 24.2656 1.23438C24.7552 1.72396 25 2.3125 25 3V18C25 18.6875 24.7552 19.276 24.2656 19.7656C23.776 20.2552 23.1875 20.5 22.5 20.5H5L0 25.5ZM3.9375 18H22.5V3H2.5V19.4062L3.9375 18Z",
    fill: "#383838"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_12312_27570",
    x: -42,
    y: -268,
    width: 464,
    height: 334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823529 0 0 0 0 0.854902 0 0 0 0 0.894118 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12312_27570"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.956863 0 0 0 0 0.972549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12312_27570",
    result: "effect2_dropShadow_12312_27570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12312_27570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12312_27570",
    x: -38,
    y: -96,
    width: 456,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.152941 0 0 0 0 0.780392 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12312_27570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12312_27570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_12312_27570",
    x: -38,
    y: -46,
    width: 456,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.152941 0 0 0 0 0.780392 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12312_27570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12312_27570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12312_27570"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -530,
    y: -512,
    width: 1440,
    height: 690,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12312_27570"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -262,
    width: 440,
    height: 310,
    rx: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sms-icon.f96b2a09edcb9ec868a699c6c8f6cfa8.svg";